import {NoteDialogNote as Note} from "./NoteDialogNote";
import {NoteDialogHeader as Header} from "./NoteDialogHeader";
import {NoteDialogNoteWrapper as Wrapper} from "./NoteDialogNoteWrapper";

export const NoteDialogComponents = {
  Header,
  Note,
  Wrapper,
};
